import { LunaTabName } from "@/types";

import { Problems, Solutions, Examples, Diagrams } from "./index";

interface TabContentProps {
  activeTab: LunaTabName;
  inRecordedLessonView: boolean;
}

const TabContent = ({ activeTab, inRecordedLessonView }: TabContentProps) => {
  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: activeTab === LunaTabName.Problems ? "block" : "none",
          height: "100%",
        }}
      >
        <Problems
          inRecordedLessonView={inRecordedLessonView}
          isFocused={activeTab === LunaTabName.Problems}
        />
      </div>
      <div
        style={{
          display: activeTab === LunaTabName.Solutions ? "block" : "none",
          height: "100%",
        }}
      >
        <Solutions />
      </div>
      <div
        style={{
          display: activeTab === LunaTabName.Examples ? "block" : "none",
          height: "100%",
        }}
      >
        <Examples isFocused={activeTab === LunaTabName.Examples} />
      </div>
      <div
        style={{
          display: activeTab === LunaTabName.Diagrams ? "block" : "none",
          height: "100%",
        }}
      >
        <Diagrams />
      </div>
    </div>
  );
};

export default TabContent;
